<template>
  <a v-if="href && !disabled" :href="href" :target="blank" class="cc-btn nowrap" :class="merge(isActive(), border)" @click="handleRoute">
    <slot></slot>
  </a>
  <button v-else :disabled="disabled" class="cc-btn nowrap" :class="border" @click="click">
    <slot></slot>
  </button>
</template>

<script>
import Merge from "@/mixins/Merge.js";

export default {
  name: 'BorderlessButton',
  mixins: [
    Merge,
  ],
  props: {
    href: String,
    disabled: Boolean,
    border: {type:String, default: undefined},
  },
  computed: {
    blank() {
      return this.href && this.href.startsWith('http') ? '_blank' : undefined;
    },
  },
  methods: {
    isActive() {
      return undefined;
      //return this.href == this.$route.path ? "active" : undefined;
    },
    click() {
      this.$emit('click');
    },
    handleRoute(ev) {
      if (!this.href || this.href.startsWith('http'))
        return;

      for (const r of this.$router.options.routes) {
        if (this.href == r.path) {
          ev.preventDefault();
          //if (r.path != this.$route.path) {
            setTimeout(() => {
              this.$layout.isMenuExpanded = false;
              this.$router.push({path:this.href});
            }, 100);
            //this.$router.push({path:this.href});
          //}
          break;
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>

$anim-mode: ease-in;
$bordered-size: 16px;

.dark {
  .cc-btn {
    color: #fcfcfc;
    fill:#fcfcfc;
  }
  .cc-btn:hover {
    color: #ececec;
    fill:#ececec;
  }
  .cc-btn:active {
    color: #dcdcdc;
    fill:#dcdcdc;
  }
}

.cc-btn {
  font-family: "Raleway";
  font-size: 16px;
  font-weight: 600;
  border: none;
  background: none;
  cursor: pointer;
  user-select: none;

  padding: 0;
  display: inline-flex;
  //border: 1px solid red;

  color: $color-1;
  fill: $color-1;
  * {
    color: $color-1;
    fill: $color-1;
  }

  transition-property: color, background-color;//border-color transform;
  transition-duration: 0.1s;
  transition-timing-function: ease-in;
}

.cc-btn.active {
  pointer-events: none;

  color: $color-1-active;
  fill: $color-1-active;
  * {
    color: $color-1-active;
    fill: $color-1-active;
  }
}

button.cc-btn:disabled {
  pointer-events: none;
  // color: #0003;

  // & > * {
  //   color: #0003;
  //   fill: #0003;
  // }
  opacity: 0.33;
}

.cc-btn:hover {
  text-decoration: underline;

  color: $color-1-hover;
  fill: $color-1-hover;
  * {
    color: $color-1-hover;
    fill: $color-1-hover;
  }
}

.cc-btn:active {
  transform: translateY(1px);
  //text-shadow: 0px 0px 3px $orange-light;
  text-decoration: underline;

  color: $color-1-active;
  fill: $color-1-active;
  * {
    fill: $color-1-active;
    color: $color-1-active;
  }

  transition-duration: 0s;
}

.transparent {
  font-size: $bordered-size;
  border: 2px solid $color-1;
  border-radius: $button-border-radius;
  background: none;
  //box-sizing: border-box;
  padding: 4px 24px;
  text-decoration: none;
  justify-content: center;
}

.transparent:hover {
  color: white;
  text-decoration: none;
  border-color: $color-1-hover;
  background: $color-1-hover;
  border: none;
  padding: 6px 26px;
}

.transparent:active {
  color: white;
  border-color: $color-1-active;
  background: $color-1-active;
  text-decoration: none;
  border: none;
  padding: 6px 26px;
}

.blue {
  color: white;
  font-size: $bordered-size;
  //border: 2px solid $color-2-1;
  background: linear-gradient(90deg, $color-2-1, $color-2-2);
  //background: $color-2-2;
  border-radius: $button-border-radius;
  //box-sizing: border-box;

  padding: 12px;
  @media (max-width:1200px) {
    padding: 12px 4px;
  }

  text-decoration: none;
  justify-content: center;
}

.blue:hover {
  color: white;
  text-decoration: none;
  //border-color: $color-2-1-hover;
  background: linear-gradient(90deg, $color-2-1-hover, $color-2-2-hover);
  //background: $color-2-2-hover;
}

.blue:active {
  //border-color: $color-2-active;
  background: $color-2-active;
  text-decoration: none;
}

button.blue:disabled {
  color: white;
  opacity: 0.5;
}

</style>
